import { StatusCodes } from "http-status-codes";
import { LogLevel } from "../common/utils/enum.logLevel";
import { LogContext } from "../common/utils/logging";
import { IGenericFailureResult } from "../interfaces/IResults";

export interface GenericFailureParams {
  statusCode: StatusCodes;
  message: string;
  messageWithSensitiveData?: undefined | string;
  errors?: unknown;
  description?: undefined | string;
  logContext?: undefined | LogContext;
  logLevel?: undefined | LogLevel;
}

export class GenericFailure extends Error implements IGenericFailureResult {
  override name = "GenericFailure";
  success = false as const;
  statusCode: StatusCodes;
  messageWithSensitiveData: string;
  errors?: unknown;
  description?: undefined | string;
  logContext?: undefined | LogContext;
  logLevel: LogLevel;

  constructor({
    statusCode,
    message,
    errors,
    description,
    logContext,
    messageWithSensitiveData,
    logLevel,
  }: GenericFailureParams) {
    super(message);
    this.messageWithSensitiveData = messageWithSensitiveData ?? message;
    this.statusCode = statusCode;
    this.errors = errors;
    this.description = description;
    this.logContext = logContext;
    this.logLevel = logLevel ?? LogLevel.ERROR;
  }
}
